// extracted by mini-css-extract-plugin
module.exports = {"treeCounterSection":"TreeCounter_treeCounterSection__1dMV2","treeCounter":"TreeCounter_treeCounter__2jjwn"};